import { Link } from 'react-router-dom';
import SEO from '@/components/SEO';
import { Button } from '@/components/ui/button';

const FeedbackThankYou = () => {
  return (
    <>
      <SEO
        title="Thank You"
        description="Thank you for your feedback."
        noindex
      />
      
      <div className="min-h-screen bg-slate-50 flex flex-col">
        {/* Header - Logo Only */}
        <header className="py-6 px-4">
          <div className="flex justify-center">
            <Link to="/">
              <img 
                src="/uploads/hero-professional-success-wc.jpg" 
                alt="SeniorThrive" 
                className="h-10 md:h-12"
              />
            </Link>
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-1 flex items-center justify-center px-4 py-8">
          <div className="w-full max-w-[600px] bg-white rounded-xl shadow-raised p-8 md:p-12 text-center">
            {/* Brian's Photo */}
            <div className="flex justify-center mb-6">
              <img 
                src="/images/brian-fluhr.jpeg" 
                alt="Brian Fluhr, Founder of SeniorThrive" 
                className="w-20 h-20 rounded-full object-cover border-2 border-slate-100"
              />
            </div>

            {/* Headline */}
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              I appreciate your honesty.
            </h1>

            {/* Sub-headline */}
            <p className="text-xl md:text-2xl text-slate-700 font-medium mb-6">
              "I read every response personally."
            </p>

            {/* Body Text */}
            <div className="space-y-4 text-lg text-slate-600 mb-8">
              <p>
                Your feedback is incredibly helpful. It's the only way we can build a tool that truly works for families like yours.
              </p>
              <p>
                You are all set. Your account is still active on the Free plan, and we are glad to have you with us.
              </p>
            </div>

            {/* CTA Button */}
            <Button asChild size="lg" className="text-lg px-8 py-6">
              <Link to="/">Return to Home</Link>
            </Button>

            {/* Signature */}
            <p className="mt-8 text-slate-500 text-sm">
             , Brian Fluhr, Founder
            </p>
          </div>
        </main>

        {/* Footer */}
        <footer className="py-6 px-4 text-center text-sm text-slate-500">
          <p>© {new Date().getFullYear()} SeniorThrive. All rights reserved.</p>
          <div className="mt-2 space-x-4">
            <Link to="/privacy" className="hover:text-slate-700 hover:underline">Privacy</Link>
            <Link to="/terms" className="hover:text-slate-700 hover:underline">Terms</Link>
          </div>
        </footer>
      </div>
    </>
  );
};

export default FeedbackThankYou;
